import React from "react";
import CTAButtons from "@components/new-ui/CTAButtons";
import { isJSXElement } from "@utils/common";

type SecondaryCTASectionProps = {
    title: string;
    description: string | JSX.Element;
    primaryButtonText?: string;
    urlLink?: string;
    onPrimaryClick?: () => void;
    ctaButton?: JSX.Element;
};

const SecondaryCTASection: React.FC<SecondaryCTASectionProps> = ({ title, description, primaryButtonText, urlLink, onPrimaryClick, ctaButton }) => {
    return (
        <section className="my-20">
            <div
                className="w-full max-w-6xl mx-auto text-center py-10 px-8 rounded-md"
                style={{ background: "linear-gradient(103.32deg, #EDF4FF 28.71%, #D2DDFF 84.45%, #84A2FF 136.43%)" }}
            >
                <h2 className="md:text-5xl text-3xl font-bold mb-6 text-gray-900" style={{ fontFamily: "Degular Display" }}>
                    {title}
                </h2>
                {isJSXElement(description) ? (
                    description
                ) : (
                    <p className="text-xl font-inter text-gray-900 mb-10" dangerouslySetInnerHTML={{ __html: typeof description === "string" ? description : "" }} />
                )}
                {ctaButton ?? <CTAButtons primaryButtonText={primaryButtonText} {...(onPrimaryClick ? { onPrimaryClick } : { urlLink })} className="mx-auto" />}
            </div>
        </section>
    );
};

export default SecondaryCTASection;
